
import {
    SET,
    REINIT
} from './types';

import {
    Actions,
} from './actions';

import {
    TimeSlotModal
} from './timeslotsmodal';

export const timeslotsathenastate = (
    context: any,
    initial?:TimeSlotModal[],
) => {
    const initValue = initial || [];

    return (
        state: TimeSlotModal[] = initValue,
        action:Actions,
    ) => {
        const {
            type,
            payload,
        } = action;
        let updated = state; 
        switch (type) {
            case SET:
                updated = payload;
                break;

            case REINIT:
                console.log('Timeslots Redux: REINIT action received, resetting to initial state');
                updated = initValue;
                break;
                
            default:
                console.log('Timeslots Redux: Unknown action type:', type);
        }
        
        console.log('Timeslots Redux: State after update:', {
            updatedLength: Array.isArray(updated) ? updated.length : 'not array',
            updatedType: typeof updated
        });
        
        return updated;
    }
};

